import { render, staticRenderFns } from "./page-cgu.vue?vue&type=template&id=0d6d66dc&"
import script from "./page-cgu.vue?vue&type=script&lang=js&"
export * from "./page-cgu.vue?vue&type=script&lang=js&"
import style0 from "./page-cgu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports